<p-card styleClass="very-compact-card p-3">
  <div class="flex justify-content-between align-items-center flex-wrap gap-2">
    <div class="flex align-items-center gap-2">
      <h3 class="m-0">{{ isCardWidgetTypeHelpdesk ? 'Сделка' : 'Сделки' }}</h3>
      <crm-button-show-and-hide
        [isShow]="dealsShow"
        (isShowChange)="showButtonChange.emit($event)"></crm-button-show-and-hide>
      <button
        *ngIf="dealsShow && isDisplayCreate"
        pButton
        pTooltip="Создать сделку"
        tooltipPosition="top"
        icon="pi pi-plus"
        class="p-button-success-create"
        (click)="createDeal.emit()"></button>
    </div>
    <div
      *ngIf="dealsShow"
      class="flex align-items-center">
      <button
        *ngIf="!isCardWidgetTypeClient"
        pButton
        [pTooltip]="isCardWidgetTypeHelpdesk ? 'Прикрепить сделку' : 'Редактировать сделки'"
        [tooltipPosition]="isCardWidgetTypeHelpdesk ? 'left' : 'top'"
        icon="pi pi-pencil"
        class="p-button-edit"
        (click)="editDeal.emit()"></button>

      <p-selectButton
        *ngIf="!isCardWidgetTypeHelpdesk"
        class="ml-3 select-button-widget"
        [options]="dealListKindOptions"
        [(ngModel)]="statusKind"
        (onChange)="changeDealFilter.emit($event.value)">
        <ng-template let-item>
          <div
            [pTooltip]="item.label"
            tooltipPosition="top"
            class="select-button-tooltip"></div>
          <i [class]="item.icon"></i>
        </ng-template>
      </p-selectButton>
    </div>
  </div>

  <div
    *ngIf="dealsShow"
    class="mt-3">
    <div
      class="max-h-29rem overflow-y-auto overflow-x-hidden"
      (scroll)="scrollEnd.emit($any($event.target))">
      <crm-table
        *ngIf="isDealExist && loading === false"
        name="{{ source }}.deals"
        [columns]="columns"
        [values]="getDealValues"
        [paginationLoading]="paginationLoading"
        styleClass="sticky-header card-table p-datatable-sm">
        <ng-template
          #rowTemplate
          let-deal="item">
          <tr *ngIf="toDeal(deal) as deal">
            <td>
              <a
                class="white-space-nowrap"
                crmConditionalRouterLink
                [routerLink]="['/deal/card/', deal.id ]"
                >
                Сделка {{ deal.number }}
              </a>
              <p class="text-gray-400 text-sm">{{ deal.name }}</p>
            </td>
            <td>
              <a
                *ngIf="deal.contragent; else notContragent"
                crmConditionalRouterLink
                [routerLink]="['/client/contragent/card/', deal.contragent?.id ]"
                >
                {{ deal.contragent?.name }}
              </a>
              <ng-template #notContragent>Отсутствует</ng-template>
            </td>
            <td>
              <crm-status-label
                [name]="deal.status.name"
                [color]="deal.status.color"></crm-status-label>
            </td>
          </tr>
        </ng-template>
      </crm-table>

      <p
        *ngIf="!isDealExist && loading === false"
        class="text-xl font-medium">
        {{ isCardWidgetTypeHelpdesk ? 'Нет сделки' : 'Нет сделок' }}
      </p>

      <crm-spinner
        *ngIf="loading"
        top="mt-4"></crm-spinner>
    </div>

    <div
      class="flex"
      *ngIf="!isCardWidgetTypeHelpdesk">
      <a
        *ngIf="isDealExist && loading === false"
        pButton
        [label]="getLabel()"
        class="p-button-round p-button-text p-button-sm p-button-info cursor-pointer -ml-3"
        icon="pi pi-external-link"
        (click)="isShowCount ? navigateToDealList.emit() : directToDealList()"></a>
    </div>
  </div>
</p-card>
